import update from 'immutability-helper';
import {GET_ORGANISATION_SUCCESS, GET_USER_ORGANISATION_SUCCESS} from '../constants/actionTypes';

const initialState = {
  currentOrganisation: [],
  organisation: {}
};

const organisation = (state = initialState, action) => {
  switch (action.type) {
    case GET_USER_ORGANISATION_SUCCESS:
      return update(state, {
        currentOrganisation: {
          $set: action.payload.org,
        },
      });
    case GET_ORGANISATION_SUCCESS:
      return update(state, {
        organisation: {
          $set: action.payload.organisation,
        },
      });
    default:
      return state;
  }
};

export default organisation;
